export default {
  SET_CONTENT: 'CMS / SET CONTENT',
  SET_MASTER_LIST: 'CMS / SET MASTER LIST',
  SET_IS_LOADING: 'CMS / SET IS LOADING',
  SET_UID: 'CMS / SET UID',
} as const;
